<script>
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();
    export let actions = [];
    let buttons = [
        { action: "create", title: "Create New" },
        { action: "drag-on-map", title: "Drag on Map" },
        { action: "edit", title: "Edit" },
        { action: "export", title: "Export" },
        { action: "find-on-map", title: "Find on Map" },
        { action: "print", title: "Print" },
    ];

</script>

<div class="lp-button-panel">
    {#each actions as action}
        <button class="lp-button" on:click={() => dispatch(action)}>
            {buttons.find(x => x.action == [action]).title}
        </button>
    {/each}
</div>

<style>
    .lp-button-panel {
        background-color: rgb(240, 240, 240);
        padding: 8px 0;
        text-align: center;
        margin: auto;
    }
    .lp-button {
        color: #0a6ebd;
        border-radius: 5px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 0.75rem;
        padding: 0.25rem 0.75rem;
        cursor: pointer;
        border: 1px solid #0a6ebd;
        margin: 0 0.25rem;
    }
    .lp-button:hover  {
        background-color: rgba(248, 248, 248);
    }
</style>
